import { useEffect } from 'react'
import { EventNames } from '../../../../types/misc.types'
import { trackEvent } from '../../../../utils/appBridge'
import BottomSheetContent from '../../BottomSheetContent'

export const UnavailableForWithdrawalBottomSheet = ({
  onDismiss,
  ScreenName
}: {
  onDismiss: () => void
  ScreenName: string
}) => {
  const heading = 'Unavailable for withdrawal'
  useEffect(() => {
    trackEvent({
      eventName: EventNames.KnowMoreBottomSheetLoad,
      payload: {
        eventId: heading,
        ScreenName
      }
    })
  }, [])

  return (
    <BottomSheetContent
      heading={heading}
      onDismiss={onDismiss}
      bottomSheetHeadingClassName='!font-[500] !mb-3'
      bottomSheetBodyClassName='!px-0 !pb-4'
    >
      <div className='text-[14px] font-[400] text-[#6A6E6E] leading-[150%] px-5 pl-[22px]'>
        Your fund can’t be withdrawn because it’s either locked in, held in an external demat account, or pledged.
      </div>
    </BottomSheetContent>
  )
}
